import { Money } from '../../../../../../shared/features/domain/value-objects/Money.ts';
import { ContractId } from '@services/MarppleShop/features/Funding';
import { makeBlindUser } from '@modules/User/Blind/S/blind';

export class FundingSupporter {
  public readonly contractId?: ContractId;
  public readonly userId: number;
  public readonly name: string;
  public readonly email: string;
  public readonly nickName: string;
  public readonly profileImage: string | null;
  public readonly isHidden: boolean;
  public readonly money: Money;
  public readonly createdAt: Date;

  private constructor(
    contractId: ContractId | undefined,
    userId: number,
    name: string,
    email: string,
    nickName: string,
    profileImage: string | null,
    isHidden: boolean,
    money: Money,
    createdAt: Date,
  ) {
    const {
      email: maskedEmail,
      nickName: maskedNickName,
      profileImage: maskedProfileImage,
    } = this.toMask(userId, name, email, nickName, profileImage, isHidden);

    this.contractId = contractId;
    this.userId = userId;
    this.name = name;
    this.email = maskedEmail;
    this.nickName = maskedNickName;
    this.profileImage = maskedProfileImage;
    this.isHidden = isHidden;
    this.money = money;
    this.createdAt = createdAt;
  }

  isBlind() {
    return this.isHidden;
  }

  private toMask(
    userId: number,
    name: string,
    email: string,
    nickName: string,
    profileImage: string | null,
    isHidden: boolean,
  ) {
    const { email: maskedEmail } = makeBlindUser({ id: userId, email, name });

    return {
      email: maskedEmail,
      nickName: isHidden ? ET('creator_shop::fan_letters::hidden_user') : nickName,
      profileImage: isHidden ? null : profileImage,
    };
  }

  public toData() {
    return {
      id: this.contractId?.value,
      user_id: this.userId,
      nick_name: this.nickName,
      profile_image: this.profileImage,
      created_at: this.createdAt,
      money: {
        kr: this.money.toKRW().getAmount(),
        en: this.money.toUSD().getAmount(),
        jp: this.money.toJPY().getAmount(),
      },
    };
  }

  static of(
    contractId: number | undefined,
    userId: number,
    name: string,
    email: string,
    nickName: string,
    profileImage: string | null,
    isHidden: boolean,
    amount: number,
    createdAt: Date,
  ) {
    return new FundingSupporter(
      contractId ? ContractId.of(contractId) : undefined,
      userId,
      name,
      email,
      nickName,
      profileImage,
      isHidden,
      Money.of(amount),
      createdAt,
    );
  }
}
